import PartnerLogo from './src/PartnerLogo';
import PartnerAvatar from './src/PartnerAvatar';

export { PartnerLogo, PartnerAvatar };
